import css from 'styled-jsx/css'
import { colors } from '../../../styles'
import btnStyles from '../../Button/styles'

export const buttonStyles = btnStyles

export const autocompleteStyles = css`
:global(.autocomplete-wrapper){
    max-height: calc(100dvh - 200px);
    z-index: 1;
    width: 100%;
    max-width: 800px;
    list-style: none;
    margin-top: 12px;
    background: ${colors.elevatedBg};
    border: 1px solid ${colors.textHoverPurple};
    box-sizing: border-box;
    box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.11);
    border-radius: 8px;
    left: 0;
    overflow: hidden;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #C448F0 transparent;
  }

  .autocomplete-container{
    overflow-y: auto;
    padding: 0;
    margin: 0;
    height: 100%;
  }

 .autocomplete-result {
   padding: 12px 16px;
    display: flex;
    cursor: pointer;
  }

 .autocomplete-result[aria-selected="true"] {
  background-color: ${colors.ctvBg};
  }

  .autocomplete-result :global(.cardLabel) {
    color: white;
  }

 :global(.autocomplete-result[aria-selected="true"] p),
 :global(.autocomplete-result[aria-selected="true"] .cardLabel) {
   color: ${colors.textHoverPurple};
 }

.autocomplete-result :global(p:first-child) {
  margin-bottom: 2px;
}

 .autocomplete-result-image{
   width: 99px;
   min-width: 99px;
   margin-right: 16px;
  }
`

export const searchboxStyles = css`
.st-default-search-input-wrap {
  width: 100%;
  flex-wrap: wrap;
}

.searchbox-input, .st-default-search-input{
  font-family: 'Source Sans Pro', 'Tahoma', sans-serif;
  background: ${colors.textInput};
  border: 1px solid ${colors.IconButtonPurple};
  box-shadow: none;
  color: white;
  outline: 0;
  font-size: 16px;
  -moz-appearance: none;
  -webkit-appearance: none;
  width: 100%;
  max-width: 524px;
  padding: 9px 12px 9px 44px;
  border-radius: 4px;
  position: relative;
  left: 0;
  margin-bottom: 8px;
  font-display: swap;
}
.searchbox-input::placeholder, st-default-search-input-wrap{
  color: white;
}
.st-default-search-input{
  box-sizing: border-box;
  height: 40px;
}

.searchbox-input:focus{
  border-color: ${colors.textHoverPurple};
}

.st-default-search-input-wrap{
  width: 100%;
  align-self: flex-start;
  position: relative;
}
:global(.sui-search-box){
  display: flex;
  justify-content: center;
}

.sui-search-box__wrapper{
  display: flex;
  flex-basis: 500px;
  align-items: center;
  position: relative;
  color: ${colors.midGrey2};
}

.sui-search-box__wrapper :global(.SearchIcon),
.st-default-search-input-wrap :global(.SearchIcon){
  color: ${colors.primaryText};
  position: absolute;
  z-index: 1;
  left: 14px;
  top: 20px;
  transform: translateY(-50%) scaleX(-1);
  }

.sui-search-box__wrapper :global(input[type="submit"]),
.st-default-search-input-wrap :global(.primary-btn){
  padding: 10px 16px;
  min-width: 109px;
  margin: 0 0 8px;
  -webkit-appearance: none;
}

@media (min-width: 600px) {
  .st-default-search-input {
    max-width: 500px;
  }
}

@media (min-width: 768px) {
  input {
    font-size: 20px;
    left: -30px;
    padding-left: 48px;
  }

  .search-icon-container {
    width: 30px;
    height: 30px;
    left: 8px;
  }
}
`
